import { render, staticRenderFns } from "./complainList.vue?vue&type=template&id=a5f0ac70&scoped=true"
import script from "./complainList.vue?vue&type=script&lang=js"
export * from "./complainList.vue?vue&type=script&lang=js"
import style0 from "./complainList.vue?vue&type=style&index=0&id=a5f0ac70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f0ac70",
  null
  
)

export default component.exports